/** @jsxImportSource @emotion/react */

import { useMediaQuery, useTheme, Grid, Typography, IconButton, DialogContent, Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import CircularProgressBar from "../../Components/CircularProgressBar";
import Sidebar from './Sidebar';
import { deleteCookie } from "../../Helper/Cookies/cookies";
import LogoutIcon from '@mui/icons-material/Logout';
import config from '../../config';
import getCookie, { getToken, setCookieNew, setTokens } from '../../Helper/Cookies/cookies';
import axios from '../../Helper/Axios/interceptor';
import { addStageData } from '../../Helper/Redux/reducers/upDown';
import { appStages } from '../../Helper/AppStepperData';
import { updateStepper } from '../../Helper/Redux/reducers/upDown';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState,useContext } from "react";
import Popup, { PopupTitle } from "../../Components/CustomPopup";
import { Il8nContext } from '../../Helper/i18n';

function Layout(props) {
    const { children, showSidebar, hideSidebarGrid, withOutSidebar, isObjectionScreen, hideLogoutIcon } = props;
    const theme = useTheme();
    const store = useSelector(state => state.storeState.stage)
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [openLocalizationDialog, setOpenLocalizationDialog] = useState(false)
    const [currentLocalizationValue, setCurrentLocalizationValue] = useState("en")
    const localeText = useContext(Il8nContext)

    let shouldDisplayLogoutIcon = (!isSmallScreen && !hideLogoutIcon)

    const toggleLocalizationDialog = () => {
        setOpenLocalizationDialog(!openLocalizationDialog)
    }

    const handleCurrentLocalizationChange = (e) => {
        setCurrentLocalizationValue(e.target.value)
        toggleLocalizationDialog()
        dispatch(addStageData({ ...store, currentLocalizationValue : e.target.value }))
    }

    return (
        <div className="main-wrap" css={{}}>
            <div css={{ padding: "20px", position: "fixed", width: "100%", top: "0", backgroundColor: "#24B7CC", zIndex: "99" }}>
                <img src="images/tb_logo.svg" alt="Logo" css={{ position: "relative", maxWidth: "200px" }} />
            </div>
            {shouldDisplayLogoutIcon &&
                <>
                    {
                        //store?.personalDetails?.fName &&
                        <Grid>
                            <Typography variant="h6" component="h2" css={{ position: "fixed", right: '10px', top: '30px', zIndex: 103, color: 'white' }} >
                                {/* {`Hi, ${store?.personalDetails?.fName}`} */}
                                <IconButton onClick={(e) => {
                                    deleteCookie("token");
                                    localStorage.clear();
                                    deleteCookie("refresh_token");
                                    deleteCookie("isEmailMobileVerficationFailed") 
                                    window.location.href = `${process.env.REACT_APP_LOGIN_URL}${btoa(window.location.origin)}&isRegUser=1`;
                                }} color="primary" aria-label="upload picture" component="label" css={{ color: 'white' }} >
                                    <LogoutIcon />
                                </IconButton>
                            </Typography>
                        </Grid>
                    }
            </>
            }   
            {(isSmallScreen && !hideSidebarGrid) &&
                <CircularProgressBar
                    style={{ position: "absolute", right: 0, top: 0, padding: '55px 12px 12px 12px', zIndex: '103' }}
                    isObjectionScreen={isObjectionScreen}
                />
            }
            {/* <div css={{ position: "fixed", right: shouldDisplayLogoutIcon ? '70px' : "20px", top: shouldDisplayLogoutIcon ? '38px' : "20px", zIndex: 103, color: 'white', cursor: "pointer" }}>
                <Typography variant={"body1"} fontWeight={"bold"} css={{textTransform:"capitalize"}} onClick={toggleLocalizationDialog}>
                    {currentLocalizationValue}
                </Typography>
            </div> */}
            <div className={`app-wrap ${withOutSidebar ? 'login-wrap' : ''}`} css={
                isSmallScreen ?
                    { /* position: "absolute",  top: "10%",  width: "100vw", height: "100vh" */ }
                    :
                    {
                        position: "relative", display: "flex",
                        ...(!hideSidebarGrid ? {/* marginTop: 80, height: "calc(100% - 80px)",*/ width: "100%" }
                            : {})
                    }}>
                <Grid container className="grid-wrap" css={{ height: "100%", margin: "auto", paddingTop: 0, paddingBottom: "20px", width: isSmallScreen ? "100%" : "100%" }}>
                    {!hideSidebarGrid && <Grid item xl={2} lg={1.5} md={3} xs={12} style={isSmallScreen ? { height: 55 } : {}}>
                        {showSidebar && <Sidebar isObjectionScreen={isObjectionScreen} isSmallScreen={isSmallScreen} />}
                    </Grid>}
                    <Grid className={hideSidebarGrid ? "login-container" : ''} item xl={10} lg={10.5} md={9} xs={12} css={isSmallScreen ? { height: "calc(100% - 55px)", overflowY: "auto" } : { height: "100%" }}>
                        {children}
                    </Grid>
                </Grid>
            </div>
            <Popup 
                open={openLocalizationDialog}
                maxWidth={"xs"}
                fullWidth
            >
                <PopupTitle onClose={toggleLocalizationDialog}>{localeText?.layoutpreferred}</PopupTitle>
                <DialogContent>
                    <div css={{ width: "100%", marginTop:"10px"}}>
                        <FormControl fullWidth>
                            <InputLabel id="localizationSelection">{localeText?.layoutLanguage}</InputLabel>
                            <Select
                                labelId="localizationSelection"
                                id="localizationSelection"
                                fullWidth
                                value={currentLocalizationValue}
                                label="Language"
                                onChange={handleCurrentLocalizationChange}
                            >
                                <MenuItem value={"en"}>En - English</MenuItem>
                                <MenuItem value={"fr"}>Fr - French</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
            </Popup>
        </div >
    );
}

export default Layout;